<template>
  <div data-testid="lca-tab" class="flex w-full flex-col gap-6">
    <div>
      In light of increasing pressure for transparency and carbon accounting,
      LCAs are becoming widely used to provide holistic, detailed assessments of
      environmental impacts. LCA is a scientifically proven method to quantify
      impacts of a product and its process system across the entire value chain,
      going beyond assessing carbon emissions alone.
    </div>
    <EsgLcaDescriptionSection :market="market" />
    <EsgLcaGlobalSection />
    <EsgLcaAcrossSection />
  </div>
</template>

<script setup lang="ts">
import EsgLcaDescriptionSection from '~/components/sustainability/LcaDescriptionSection.vue'
import EsgLcaGlobalSection from '~/components/sustainability/LcaGlobalSection.vue'
import EsgLcaAcrossSection from '~/components/sustainability/LcaAcrossSection.vue'
import type { TMarketServiceConfig } from '~/src/types/markets'

defineProps<{
  market: TMarketServiceConfig
}>()
</script>
